import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { HelmetProvider } from "react-helmet-async";
import App from './App';

const rootElement = document.getElementById('root');

const AppTree = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, AppTree);
} else {
  createRoot(rootElement).render(AppTree);
}




//import React from 'react';
//import ReactDOM from 'react-dom';
//import { HelmetProvider } from "react-helmet-async";
//import App from './App';

//ReactDOM.render(
//	<React.StrictMode>
//		 <HelmetProvider>
//		 {/*<meta name="viewport" content="width=device-width, initial-scale=1" />?*} {/* Add this line */}
//		<App />
//		</HelmetProvider>
//	</React.StrictMode>,
//	document.getElementById('root')
//);




//import React from 'react';
//import ReactDOM from 'react-dom/client';
//import './index.css';
//import App from './App';
//import reportWebVitals from './reportWebVitals';

//const root = ReactDOM.createRoot(document.getElementById('root'));
//root.render(
  //<React.StrictMode>
    //<App />
  //</React.StrictMode>
//);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
